import React, { useState } from "react";

import ScreenshotCarouselDialog from "./ScreenshotCarouselDialog";
import type { ScreenshotRef, ScreenshotUrlResolver } from "./ScreenshotCarousel";

/**
 * A screenshot carousel opened from anywhere in a screen. There is no separate "is it open" flag:
 * the dialog is open exactly while it has screenshots to show, and closing clears them.
 *
 * Render `carousel` once, wherever in the tree suits the layout (the dialog portals out anyway),
 * and hand `showScreenshots` to whatever should open it. Images come from the company router
 * unless `resolveUrl` says otherwise.
 */
export const useScreenshotCarousel = (resolveUrl?: ScreenshotUrlResolver) => {
  const [screenshots, setScreenshots] = useState<ScreenshotRef[]>([]);

  const carousel = (
    <ScreenshotCarouselDialog
      open={screenshots.length > 0}
      screenshots={screenshots}
      onOpenChange={open => {
        if (!open) setScreenshots([]);
      }}
      resolveUrl={resolveUrl}
    />
  );

  return { showScreenshots: setScreenshots, carousel };
};
